'use client';

import {QueryClientProvider} from '@tanstack/react-query';
import {ReactQueryDevtools} from '@tanstack/react-query-devtools';
import {createQueryClient} from '@/matic/config/query-client';

// Create QueryClient instance outside component to avoid recreation
const queryClient = createQueryClient();

type QueryProviderProps = {
  children: React.ReactNode;
};

/**
 * QueryProvider component that provides TanStack Query functionality
 * Includes conditional DevTools for development environment
 */
export function QueryProvider({children}: QueryProviderProps) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {process.env.NODE_ENV === 'development' && (
        <ReactQueryDevtools
          initialIsOpen={false}
          buttonPosition="bottom-left"
        />
      )}
    </QueryClientProvider>
  );
}
